import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import PlantBackground from "components/Layouts/PlantBackground";
import {
  showFailureNotification,
  showSuccessNotification,
} from "store/actions/notification";
import { loginRequest } from "store/actions/login";
import { cognitoRespondToNewPassword } from "services/cognitoAuth";

import styles from "./NewPassword.module.css";

// Reached when Cognito returns NEW_PASSWORD_REQUIRED on login — the user has
// to set a new password before tokens are issued. Session + email are passed
// via location.state from the login saga.
const NewPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { email, session } = location.state || {};

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  if (!email || !session) {
    history.replace("/login");
    return null;
  }

  const submit = async () => {
    if (!password) {
      dispatch(showFailureNotification("Password is required"));
      return;
    }
    if (password !== confirm) {
      dispatch(showFailureNotification("Passwords do not match"));
      return;
    }
    setLoading(true);
    try {
      // Cognito returns the IdToken on a successful challenge response.
      await cognitoRespondToNewPassword(email, session, password);
      dispatch(showSuccessNotification("Password updated. Signing you in..."));
      // Password is now permanent — re-run the login flow which will exchange
      // a fresh IdToken for our app JWT through the existing saga.
      dispatch(loginRequest(email, password, history));
    } catch (e) {
      dispatch(showFailureNotification(e?.message || "Failed to set password"));
    } finally {
      setLoading(false);
    }
  };

  const onKeyUp = (e) => {
    if (e.key === "Enter") submit();
  };

  return (
    <PlantBackground>
      <div className={styles.container} onKeyUp={onKeyUp}>
        <div className={styles.formContainer}>
          <label className={styles.label}>Set a new password</label>
          <p style={{ color: "#fff", marginBottom: 12, fontSize: 13 }}>
            Your administrator reset your password. Choose a new one to
            continue.
          </p>
          <div className={styles.form}>
            <input
              type="password"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              style={inputStyle}
            />
            <input
              type="password"
              placeholder="Confirm new password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
              style={inputStyle}
            />
            <footer className={styles.footer}>
              <button
                onClick={submit}
                className={styles.submit}
                type="button"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Confirm"}
              </button>
            </footer>
          </div>
        </div>
      </div>
    </PlantBackground>
  );
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  marginTop: 10,
  borderRadius: 4,
  border: "1px solid #ccc",
  fontSize: 14,
};

export default NewPassword;
